  import React, { useState, useEffect, useRef } from "react";
  import { Form } from "react-bootstrap";
  import cookie from "react-cookies";
  import { connect } from "react-redux";
  import API from "api.js";
  import { Navigate, NavLink, Link, useNavigate, useLocation } from "react-router-dom";
  import { setToken, setUser, setLogo, setSub, setLoader, setRegionAccess, setInstitute, setCoreSubscription, setTheme } from "action/index.js";
  import SimpleReactValidator from "simple-react-validator";
  import { Helmet } from "react-helmet";
  import ReactGA from "react-ga";
  import ReactPixel from "react-facebook-pixel";
  // import NotificationAlert from "react-notification-alert";
  import FacebookLogin from "react-facebook-login";
  import { GoogleLogin } from "@react-oauth/google";
  import GoogleBtn from "components/GoogleBtn/GoogleBtn";
  import { toast } from 'react-toastify';

  import { store } from "store/index";
  import { isMobile } from "react-device-detect";
  import LaLoader from "components/Loader/LaLoader.jsx";
  import { useDispatch, useSelector } from "react-redux";
  import { setAlert } from "action/index";
  import { getSubdomain, isWhiteLabel } from "utils/whiteLabel";
  import { applyTheme, mergePartnerTheme, getMockTheme } from "utils/whiteLabelTheme";

  const REMEMBERED_EMAIL_KEY = "rememberedEmail";

  const getRememberedEmail = () => {
    try {
      return localStorage.getItem(REMEMBERED_EMAIL_KEY) || "";
    } catch (e) {
      return "";
    }
  };

  const saveRememberedEmail = (email) => {
    try {
      localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
    } catch (e) {
      console.error("Failed to save remembered email:", e);
    }
  };

  const clearRememberedEmail = () => {
    try {
      localStorage.removeItem(REMEMBERED_EMAIL_KEY);
    } catch (e) {
      console.error("Failed to clear remembered email:", e);
    }
  };

  const mapStateToProps = (state) => {
    return {
      token: state.token,
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      setToken: (tok) => dispatch(setToken(tok)),
      setUser: (user) => dispatch(setUser(user)),
      setSub: (sub) => dispatch(setSub(sub)),
      setLogo: (sub) => dispatch(setLogo(sub)),
      setRegionAccess: (region_access) => dispatch(setRegionAccess(region_access)),
      setInstitute: (institute) => dispatch(setInstitute(institute)),
      setCoreSubscription: (core) => dispatch(setCoreSubscription(core)),
    };
  };

  const MESSAGE =
    "You have been logged out. Please sign in again to continue.";
  const MESSAGE_ONE = "Successfully logged out from the system.";

  const Login = (props) => {
    // White label restriction: redirect to root if white label is enabled but no subdomain
    if (isWhiteLabel() && !getSubdomain()) {
      return <Navigate to="/" replace />;
    }

    const [state, setState] = useState(() => {
      const rememberedEmail = getRememberedEmail();
      return {
        error_status: false,
        error_status_message: MESSAGE,
        alert_color: "danger",
        email: rememberedEmail || "",
        password: "",
        passwordVisible: false,
        login: false,
        error: null,
        error_bag: null,
        loginLock: false,
        rememberMe: rememberedEmail ? true : false,
        logoIcon: "/images/logol.png",
        isMainSite:
          window.location.hostname.split(".").shift() === "www" ? true : false,
      };
    });
    const dispatch = useDispatch("");
    const validatorRef = useRef(new SimpleReactValidator());
    // const notificationAlertRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [, forceUpdate] = useState();

    const WL_FALLBACK_LOGO = "/images/web-new-images/ptemax-icon.svg";
    const reduxLogo = useSelector((state) => state.logo);
    const reduxTheme = useSelector((state) => state.theme);
    const [wlLogo, setWlLogo] = useState(null);

    useEffect(() => {
      if (!isWhiteLabel()) return;
      if (reduxTheme && typeof reduxTheme === "object" && Object.keys(reduxTheme).length > 0) {
        applyTheme(reduxTheme);
      } else {
        const subdomain = getSubdomain();
        applyTheme(getMockTheme(subdomain));
      }
    }, [reduxTheme]);

    useEffect(() => {
      if (!isWhiteLabel()) return;

      const subdomain = getSubdomain();

      if (!subdomain) return;

      const bodyFormData = new FormData();
      bodyFormData.set("subdomain", subdomain);

      API({
        method: "POST",
        url: "get-logo",
        data: bodyFormData,
      })
        .then((response) => {
          const apiData = response?.data;
          const logoPath = apiData?.data;
          const themeData = apiData?.theme;

          // Logo
          if (logoPath && logoPath.trim() !== "") {
            const fullLogoUrl = logoPath.startsWith("http")
              ? logoPath
              : `${import.meta.env.VITE_API_URL}${logoPath}`;

            setWlLogo(fullLogoUrl);
            store.dispatch(setLogo(fullLogoUrl));
          } else if (reduxLogo && reduxLogo.trim() !== "") {
            // Fallback to Redux logo
            setWlLogo(reduxLogo);
          } else {
            // Final fallback
            setWlLogo("/images/web-new-images/ptemax-icon.svg");
          }

          // Theme
          if (themeData && Object.keys(themeData).length > 0) {
            const mergedTheme = mergePartnerTheme(themeData, subdomain);
            store.dispatch(setTheme(mergedTheme));
            applyTheme(mergedTheme);
          } else {
            const fallbackTheme = getMockTheme(subdomain);
            store.dispatch(setTheme(fallbackTheme));
            applyTheme(fallbackTheme);
          }
        })
        .catch(() => {
          // API failed → use existing Redux logo or fallback
          if (reduxLogo && reduxLogo.trim() !== "") {
            setWlLogo(reduxLogo);
          } else {
            setWlLogo("/images/web-new-images/ptemax-icon.svg");
          }

          applyTheme(getMockTheme(subdomain));
        });
    }, []);
    
    const handleLogoError = (e) => {
      e.target.onerror = null;
      e.target.src = WL_FALLBACK_LOGO;
      setLogoLoaded(true);
    };

    const handleLogoLoad = () => {
      setLogoLoaded(true);
    };

    const [logoLoaded, setLogoLoaded] = useState(!isWhiteLabel());

    // For white-label: show loader until wlLogo is resolved AND image finishes loading.
    // Don't render the <img> src until we have a real URL to avoid fallback flicker.
    const isWlLogoReady = !isWhiteLabel() || (wlLogo !== null);
    const loginLogo = isWhiteLabel()
      ? (wlLogo || WL_FALLBACK_LOGO)
      : "/images/web-new-images/hero_img1.png";

    useEffect(() => {
      store.dispatch(setLoader(true));
      ReactGA.initialize("UA-157984080-1");
      ReactGA.pageview(window.location.pathname + window.location.search);
      
      // ReactPixel.init("197333187452630");
      // ReactPixel.pageView();

      // 100ms delay. because at first url is /session-expired and then changes after some ms
      setTimeout(() => {
        const query =
          location?.search !== "" ? location?.search.split("?")[1] : "";

        setState((prev) => ({
          ...prev,
          error_status:
            location?.pathname === "/auth/login/session-expired" ||
              query === "logout"
              ? true
              : false,
          error_status_message: query === "logout" ? MESSAGE_ONE : MESSAGE,
          alert_color: query === "logout" ? "success" : "danger",
        }));
        if (
          location?.pathname === "/auth/login/session-expired" ||
          query === "logout"
        ) {
          if (query === "logout") {
            notify(1, MESSAGE_ONE);
          } else {
            notify(2, MESSAGE);
          }
        }
      }, 100);

      if (props.token !== null && props.token !== "null") {
        navigate("/admin/dashboard");
      }
    }, []);
    const notify = (type, message) => {
      switch (type) {
        case 1:
          toast.success(message);
          break;
        case 2:
          toast.error(message);
          break;
        default:
          toast.info(message);
          break;
      }
    };
    const postLogIn = async () => {
      if (state.loginLock) {
        return;
      }

      if (!validatorRef.current.allValid()) {
        validatorRef.current.showMessages();
        forceUpdate({});
        return;
      }
      setState((prev) => ({ ...prev, error_bag: null, loginLock: true }));
      const { executeRecaptcha } = props;

      if (!executeRecaptcha) {
        setState((prev) => ({
          ...prev,
          error_bag: "Captcha not ready",
          loginLock: false,
        }));
        return;
      }

      // Get reCAPTCHA token
      let recaptchaToken = "";
      try {
        recaptchaToken = await executeRecaptcha("login_action");
      } catch (e) {
        setState((prev) => ({
          ...prev,
          error_bag: "Captcha error",
          loginLock: false,
        }));
        return;
      }

      const bodyFormData = new FormData();
      bodyFormData.set("email", state.email.trim());
      bodyFormData.set("password", state.password);
      bodyFormData.set("subdomain", isWhiteLabel() ? getSubdomain() || "" : " ");
      bodyFormData.set("recaptcha_token", recaptchaToken);

      let res = null;
      try {
        const url = `${import.meta.env.VITE_LOGIN_URL}/api/v2/login`;

        res = await API({
          url,
          method: "POST",
          data: bodyFormData,
        });
        if (res === null || res === undefined) {
          // in case server not responding.
          toast.error("Server not responding. Please try again.");
          setState((prev) => ({ ...prev, loginLock: false }));
        } else if (res.status === 200) {
          const expires = new Date();
          expires.setDate(Date.now() + 1000 * 60 * 60);
          props.setToken(res.data.access_token);
          props.setUser(res.data.user);
          props.setInstitute(res.data.user.institute);
          if (isWhiteLabel()) props.setCoreSubscription(res.data.user.core_subscription);
          // Only set logo if it's not the default placeholder
          if (res.data.image && res.data.image !== "/images/logol.png") {
            props.setLogo(res.data.image);
          }
          props.setRegionAccess(res.data.user.region_access);                 
          console.log("[RememberMe DEBUG] status=200 branch reached. rememberMe=", state.rememberMe, "email=", state.email);
          if (state.rememberMe) {
            saveRememberedEmail(state.email.trim());
            console.log("[RememberMe DEBUG] saved email, key now =", localStorage.getItem("rememberedEmail"));
          } else {
            clearRememberedEmail();
            console.log("[RememberMe DEBUG] cleared email (rememberMe was false)");
          }
          let sub = res.data.user.active_subscription.length === 0 ? false : true;
          props.setSub(sub);
          if (res.status === 200) {
            // window.location.href  = "/admin/dashboard";
            // navigate("/admin/dashboard");
            // setState((prev) => ({...prev, login: true, loginLock: false}));
          }
        }
        else if (res.response.status === 401) {
      if (res.response.data.code === "blocked-region-access") {
        navigate("/invalid/region");
      }
    }

      } 
      catch (error) {
        const resp = error?.response;
          dispatch(
            setAlert({
              flag: true,
              type: 2,
              message: `${resp?.data?.message || "Something went wrong. Please try again."}`,
            })
          );
        setState((prev) => ({ ...prev, loginLock: false }));
        return;
      }
    };

    const submitForm = (e) => {
      e.preventDefault();
      postLogIn();
    };

    const facebookSignUp = (response) => {
      API({
        method: "POST",
        url: "/fbSignUp",
        data: response,
      })
        .then((res) => {
          afterRequest(res);
        })
        .catch((err) =>
          setState((prev) => ({
            ...prev,
            error_bag: "Something went wrong. Please try again later.",
            loginLock: false,
          }))
        );
    };

    const googleSignUp = (credentialResponse) => {
      store.dispatch(setLoader(false));
      API({
        method: "POST",
        url: "/googleSignUp",
        data: credentialResponse,
      })
        .then((res) => {
          afterRequest(res);
        })
        .catch((err) => {
          // setState((prev) => ({...prev, error_bag:"Something went wrong. Please try again later.", loginLock: false}));
        });
    };

    const afterRequest = (res) => {
      if (res.status === 200) {
        props.setToken(res.data.original.access_token);
        props.setUser(res.data.original.user);
        props.setInstitute(res.data.original.user.institute);
        if (isWhiteLabel()) props.setCoreSubscription(res.data.original.user.core_subscription);
        props.setLogo(res.data.original.image);
        let sub =
          res.data.original.user.active_subscription.length === 0 ? false : true;
        props.setSub(sub);
         props.setRegionAccess(res.data.original.user.region_access || false);
        if (res.status === 200) {
          // window.location.href = "/admin/dashboard";
          //setState((prev) => ({...prev, login: true, loginLock: false}));
        }
      } else if (res.response.status === 422) {
        setState((prev) => ({ ...prev, error: res.response }));
        let str = "";

        Object.values(res.response.data.errors).forEach((val) => {
          str += val[0] + "\n";
        });
        toast.error(str);
        setState((prev) => ({ ...prev, loginLock: false }));
      } else if (res.response.status === 402) {
        toast.error("Something went wrong. Please try again later.");
        setState((prev) => ({
          ...prev,
          loginLock: false,
        }));
      }
    };

    const changeInput = (e) => {
      let { name, value } = e.target;
      setState((prev) => ({ ...prev, [name]: value }));
    };
    const handleRememberMeChange = (e) => {
      const checked = e.target.checked;
      if (!checked) {
        // On uncheck, immediately drop any stored email.
        clearRememberedEmail();
      }
      setState((prev) => ({ ...prev, rememberMe: checked }));
    };
    const togglePasswordVisibility = () => {
      setState((prev) => ({
        ...prev,
        passwordVisible: !prev.passwordVisible,
      }));
    };

    if (state.login) {
      //return (<Navigate to="/admin/dashboard" replace />);
    }
    if (props.token) {
      return <Navigate to="/admin/dashboard" replace />;
    }

    const isRecaptchaReady = !!props.executeRecaptcha;

    return (
      <>
      {isWhiteLabel() && (
        <style>{`@keyframes wl-logo-spin { to { transform: rotate(360deg); } }`}</style>
      )}
      <div className="innerPage">
        <div className="login-page">
          <LaLoader show={state.loginLock} />
          {isWhiteLabel() ? (
          <Helmet>
            <title>PteMax Login | Access Your Account</title>
            <meta name="description" content="Login into your PteMax account and start practicing for PTE and IELTS." />
            <meta name="robots" content="index, follow" />
            <link rel="icon" sizes="76x76" type="image/svg+xml" href="/icon.svg" />
            <link rel="canonical" href={`https://ptemax.com/auth/login`} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@ptemax" />
            <meta name="twitter:title" content="PteMax Login | Access Your Account" />
            <meta name="twitter:description" content="Login into your PteMax account and start practicing for PTE and IELTS." />
            <meta name="twitter:image" content={`https://ptemax.com/images/web-new-images/ptemax-icon.svg`} />
            <meta name="twitter:image:alt" content="PteMax Logo" />
            <meta property="og:url" content={`https://ptemax.com/auth/login`} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="PteMax Login | Access Your Account" />
            <meta property="og:description" content="Login into your PteMax account and start practicing for PTE and IELTS." />
            <meta property="og:image" content={`https://ptemax.com/images/web-new-images/ptemax-icon.svg`} />
            <meta property="og:image:alt" content="PteMax Logo" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
          </Helmet>
          ) : (
          <Helmet>
            <title>LA Language Academy Login | Access Your Account</title>
            <meta name="description" content="Login into your LA Language Academy account and start practicing for NAATI, PTE and IELTS." />
            <meta name="robots" content="index, follow" />
            <link rel="icon" sizes="76x76" type="image/png" href="/favicon.png" />
            <link rel="canonical" href={`https://www.languageacademy.com.au/auth/login`} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@languageacademy" />
            <meta name="twitter:title" content="LA Language Academy Login | Access Your Account" />
            <meta name="twitter:description" content="Login into your LA Language Academy account and start practicing for NAATI, PTE and IELTS." />
            <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
            <meta name="twitter:image:alt" content="LA Language Academy Logo" />
            <meta property="og:url" content={`https://www.languageacademy.com.au/auth/login`} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="LA Language Academy Login | Access Your Account" />
            <meta property="og:description" content="Login into your LA Language Academy account and start practicing for NAATI, PTE and IELTS." />
            <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
            <meta property="og:image:alt" content="LA Language Academy Logo" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
          </Helmet>
          )}
          <div className="notification-div"></div>

          <section className={`contentOuter form-page-wrapper login-content ${isWhiteLabel() ? "mt-0 mb-5" : "mt-80"}`}>
            <form onSubmit={submitForm}>
              <div className="form-header">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="primary-heading text-center">
                        Login To <br className="d-block d-md-none" />{" "}
                        <span className={`wpl-badge pte-naati-badge text-white ${isWhiteLabel() ? "shadow-none" : ""}`} style={{  backgroundColor:"var(--la-secondary-2)"}}>
                          Your Account
                        </span>
                      </h2>
                      <div className="loginForm">
                        <div className="form-content-outer position-relative">
                          <div className="form-content">
                            {/* {state.error_bag && (
                              <Alert className="custom-error" color="warning">
                                {state.error_bag}
                              </Alert>
                            )}
                            {state.error_status && (
                              <Alert className="custom-error" color="danger">
                                {state.error_status_message}
                              </Alert>
                            )} */}
                            <div className="form-img" style={{ position: "relative", minHeight: isWhiteLabel() ? "80px" : undefined, display: "flex", alignItems: "center", justifyContent: "center" }}>
                              {isWhiteLabel() && !logoLoaded && (
                                <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <div style={{
                                    width: "36px",
                                    height: "36px",
                                    border: "4px solid #e0e0e0",
                                    borderTop: "4px solid #1FA89B",
                                    borderRadius: "50%",
                                    animation: "wl-logo-spin 0.8s linear infinite"
                                  }} />
                                </div>
                              )}
                              {isWlLogoReady && (
                                <img
                                  className="img-fluid"
                                  src={loginLogo}
                                  alt={isWhiteLabel() ? "PteMax" : "LA"}
                                  onLoad={isWhiteLabel() ? handleLogoLoad : undefined}
                                  onError={isWhiteLabel() ? handleLogoError : undefined}
                                  style={isWhiteLabel() && !logoLoaded ? { visibility: "hidden", position: "absolute" } : undefined}
                                />
                              )}
                            </div>
                            <div className="fieldOuter login-field login-email">
                              <Form.Control
                                placeholder="Email"
                                type="text"
                                name="email"
                                value={state.email}
                                onChange={(e) => {
                                  changeInput(e);
                                }}
                                autoComplete="email"
                              />
                            </div>
                            <div className="fieldOuter login-field login-password">
                              <div className="password-field">
                                <Form.Control
                                  className="form-input"
                                  placeholder="Password"
                                  type={
                                    state.passwordVisible ? "text" : "password"
                                  }
                                  name="password"
                                  value={state.password}
                                  onChange={changeInput}
                                  autoComplete="new-password"
                                />
                                <button
                                  type="button"
                                  className="password-toggle"
                                  aria-label={state.passwordVisible ? "Hide password" : "Show password"}
                                  aria-pressed={state.passwordVisible}
                                  disabled={!state.password}
                                  onClick={togglePasswordVisibility}
                                >
                                  <i
                                    className={`fa ${state.passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
                                    aria-hidden="true"
                                  />
                                </button>
                              </div>
                            </div>
                            {validatorRef.current.message(
                              "Email",
                              state.email.trim(),
                              "required"
                            )}
                            {validatorRef.current.message(
                              "Password",
                              state.password,
                              "required"
                            )}
                            <div className="rememberForgot">
                              <div className="rememberMe">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="rememberMe"
                                    id="rememberMeCheckbox"
                                    checked={state.rememberMe}
                                    onChange={handleRememberMeChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="rememberMeCheckbox"
                                  >
                                    Remember me
                                  </label>
                                </div>
                              </div>
                             {!isWhiteLabel() && (
                             <div className="forgotPwd">
                                <NavLink className="mt-5" to="/auth/forgot">
                                  <span>Forgot Password?</span>
                                </NavLink>
                              </div>
                            )}
                            </div>
                            <div className="fieldOuter mb-0">
                              {!isWhiteLabel() && (
                              <div className="d-flex justify-content-center mb-2" style={{ fontSize: "14px" }}>
                                <span style={{ color: "grey" }}>Don't have an account? <Link to="/auth/register" style={{ fontWeight: "bold", textDecoration: "underline", color: "black" }}>Register here</Link></span>
                              </div>
                              )}
                              {/* <button
                                className="primary-btn"
                                onClick={(e) => {
                                  postLogIn();
                                }}
                              >
                                Login{" "}
                                <img
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button> */}
                              <button
                                className={`primary-btn ${isWhiteLabel() ? "shadow-none" : ""}`}
                                onClick={(e) => {
                                  postLogIn();
                                }}
                                disabled={!isRecaptchaReady}
                                style={{ backgroundColor: "var(--la-secondary-2)"}}
                              >
                                {!isRecaptchaReady ? "Loading..." : "Login"}{" "}
                                <img
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button>
                            </div>
                           {
                           !isWhiteLabel() &&
                            <>
                            <div className="separator">
                              <span>OR</span>
                            </div>
                            <div className="google-btn">
                              <GoogleLogin
                                text="continue_with"
                                size="medium"
                                width={isMobile ? "200" : "400"}
                                onSuccess={googleSignUp}
                                onError={() => {
                                  console.log("Login Failed");
                                }}
                              />
                            </div>
                            </>
                            }
                          
                            {/* <div className="google-btn">
                              <GoogleBtn afterLogin={afterRequest} />
                            </div> */}
                            {/* <div className="text-center fb-parent">
                            <FacebookLogin
                              appId={import.meta.env.VITE_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              callback={facebookSignUp}
                              icon="fa-facebook"
                              cookie={false}
                              textButton="Continue with Facebook"
                            />
                          </div> */}
                          </div>
                        </div>
                      </div>

       

                      <input type="submit" style={{ display: "none" }} />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
          <div
            className="full-page-background"
            style={{
              backgroundImage: `url(/assets/img/bg/fabio-mangione.jpg)`,
            }}
          />
        </div>
        {!isWhiteLabel() && (
        <div className="rl-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="rl-content">
                  <div className="rl-outer">
                    <div className="rl-card">
                      <div>
                        <h3 className="rl-title">
                          Get our portal for your institute
                        </h3>
                        <p className="normal-text">
                          Have institute? Need portal for students?
                        </p>
                      </div>
                      <button
                        className="outline-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#instituteModal"
                      >
                        REQUEST NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </button>
                    </div>
                  </div>
                  {!isWhiteLabel() && (
                  <div className="rl-outer">
                    <div className="rl-card">
                      <h3 className="rl-title">Login to NAATI CCL Portal</h3>
                      <a
                        href="https://www.laccl.languageacademy.com.au/auth/login"
                        className="outline-btn"
                      >
                        LOG IN{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </a>
                    </div>
                  </div>
                  )}
                  {!isWhiteLabel() && (
                  <div className="rl-outer">
                    <div className="rl-card login-new-user">
                      <div>
                        <h3 className="rl-title">NEW USER?</h3>
                        <p className="normal-text">
                          Register now to obtain your Free Mock Test Material
                        </p>
                      </div>
                      <Link to="/auth/register" className="primary-btn">
                        Register NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </Link>
                    </div>
                  </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
      </>
    );
  };

  export default connect(mapStateToProps, mapDispatchToProps)(Login);
